import { utils } from '../components/Player/Helpers'

export const addAnalyticsToUrl = (
  link: string,
  pageId?: string | number,
  componentId?: string | number
): string => utils.addPageQueryParams(link, pageId, componentId)
